import React, { useState, useEffect } from 'react'; 
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import '../App.css'; 
import { useNavigate } from 'react-router-dom';
import API_BASE_URL from '../apiConfig';

const API_URL = `${API_BASE_URL}/my-assessments`;

function DashboardPage() {
  const [assessments, setAssessments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  
  const { token } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchAssessments = async () => {
      if (!token) return;
      try {
        setLoading(true);
        const params = {};
        if (searchTerm) params.search = searchTerm;
        
        const headers = { 'Authorization': `Bearer ${token}` };
        const response = await axios.get(API_URL, { headers, params });
        
        setAssessments(response.data); 
        setError(null);
      } catch (err) {
        console.error("Error fetching assessments:", err);
        setError("Could not load assessments.");
      } finally {
        setLoading(false);
      }
    };

    const delayDebounceFn = setTimeout(() => {
      fetchAssessments();
    }, 500);

    return () => clearTimeout(delayDebounceFn);

  }, [token, searchTerm]); 

  const calculateScore = (assessment) => {
    if (assessment.status !== 'Completed') return '-';
    let totalScore = 0;
    let maxScore = 0;
    if (assessment.questions) {
        assessment.questions.forEach(q => {
            if (q.answer && q.answer.score) totalScore += q.answer.score;
            maxScore += 5;
        });
    }
    if (maxScore === 0) return '-';
    return (
        <span style={{fontWeight: 'bold', color: totalScore / maxScore > 0.7 ? '#2e7d32' : '#d32f2f'}}>
            {Math.round(totalScore)} / {maxScore}
        </span>
    );
  };

  const handleRowClick = (assessment) => {
    navigate(`/assessment/${assessment.link_token}`);
  };

  const renderContent = () => {
    if (loading) return <h2 className="loading-text">Loading...</h2>;
    if (error) return <h2 className="error-message">{error}</h2>;
    
    if (assessments.length === 0) {
        if (searchTerm) return <p>No matches found in database for "{searchTerm}".</p>;
        return <p>You haven't created any assessments yet.</p>;
    }

    return (
      <table className="dashboard-table">
        <thead>
          <tr>
            <th>Job Title</th>
            <th>Candidate Email</th>
            <th>Status</th>
            <th>Score</th>
            <th>Created On</th>
          </tr>
        </thead>
        <tbody>
          {assessments.map((assessment) => (
            <tr 
              key={assessment.id} 
              onClick={() => handleRowClick(assessment)} 
              style={{ cursor: 'pointer' }}
            >
              {/* --- ADDED data-label ATTRIBUTES FOR MOBILE CSS --- */}
              <td data-label="Job Title">{assessment.job_title || 'N/A'}</td>
              <td data-label="Candidate Email">{assessment.candidate_email || 'N/A'}</td>
              <td data-label="Status">
                {/* UPDATED: .replace(' ', '-') handles "Timed Out" -> "status-timed-out" */}
                <span className={`status-badge status-${assessment.status.toLowerCase().replace(/\s+/g, '-')}`}>
                  {assessment.status}
                </span>
              </td>
              <td data-label="Score" style={{fontSize: '1rem'}}>
                {calculateScore(assessment)}
              </td>
              <td data-label="Created On">{new Date(assessment.created_at).toLocaleDateString()}</td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  };

  return (
    /* 1. FLEX FOOTER FIX */
    <div className="App" style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Navbar /> 
      
      {/* 2. HEADER FILLS SPACE */}
      <header className="App-header" style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', paddingTop: '40px', width: '100%' }}>
        
        <div className="form-container" style={{maxWidth: '1000px', width: '90%'}}>
          <h2 style={{alignSelf: 'center', marginBottom: '10px'}}>Recruiter Dashboard</h2>
          
          <div className="search-input-container">
            <input 
                type="text"
                placeholder="Search by email or job title..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="search-input"
            />
          </div>

          {renderContent()}
        </div>
      </header>
      <Footer />
    </div>
  );
}

export default DashboardPage;